/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { DDD_DD_MMM_YYYY_HH_MM_SS_A, TIME_ZONE } from "../../../../utils/const";
import Moment from "react-moment";
import "moment-timezone";
export const DateTimeColumnFormatter = (cellContent, row, rowIndex) => {
  const { createdAt = "-" } = row || {};
  return (
    <>
      <Moment
        date={createdAt}
        format={DDD_DD_MMM_YYYY_HH_MM_SS_A}
        tz={TIME_ZONE}
      />
      <> </>
    </>
  );
};
